export const LIST_PAGINATE_CONTRACTS = 'document/list/LIST_PAGINATE_CONTRACTS';
export const CONTRACT_FORM_DATA = 'document/create/CONTRACT_FORM_DATA';
export const CREATE_CONTRACT = 'document/create/CREATE_CONTRACT';
export const CONTRACT_ID = 'document/create/CONTRACT_ID';
export const CONTRACT_IS_CREATED = 'document/create/CONTRACT_IS_CREATED';
export const CONTRACT_LIST_CREATED = 'document/list/CONTRACT_LIST_CREATED';
export const CONTRACT_LIST_AWAITING_SIGN = 'document/list/CONTRACT_LIST_AWAITING_SIGN';
export const CONTRACT_LIST_SENDED = 'document/list/CONTRACT_LIST_SENDED';
export const CONTRACT_LIST_VALIDATE = 'document/list/CONTRACT_LIST_VALIDATE';
export const CONTRACT_LIST_AWAITING_NOTARY = 'document/list/CONTRACT_LIST_AWAITING_NOTARY';
export const CONTRACT_LIST_AWAITING_VALIDATION = 'document/list/CONTRACT_LIST_AWAITING_VALIDATION';
export const CONTRACT_LIST_FINALIZED = 'document/list/CONTRACT_LIST_FINALIZED';
export const CONTRACT_LIST_CANCELED = 'document/list/CONTRACT_LIST_CANCELED';
export const CONTRACT_LIST_OBJECTED = 'document/list/CONTRACT_LIST_OBJECTED';
export const CONTRACT_LIST_ALL = 'document/list/CONTRACT_LIST_ALL';
export const CONTRACT_LIST_LOADED = 'document/list/CONTRACT_LIST_LOADED';
export const PERSIST_PAGESIZE = 'document/list/PERSIST_PAGESIZE';
export const PERSIST_DATE_FILTER = 'document/list/PERSIST_DATE_FILTER';
export const SAVE_IMAGES_FROM = 'document/create/SAVE_IMAGES_FROM';

export const GET_CONTRACT = 'document/get/GET_CONTRACT';
export const CONTRACT_FETCH = 'document/list/CONTRACT_FETCH';
export const CONTRACT_PFD = 'document/get/CONTRACT_PFD';
export const GET_CONTRACT_PDF = 'document/get/GET_CONTRACT_PDF';
export const GET_PREVIEW_PDF = 'document/get/GET_PREVIEW_PDF';
export const SIGN_CONTRACT = 'document/sign/SIGN_CONTRACT';
export const CONTRACT_IS_SIGNED = 'document/sign/CONTRACT_IS_SIGNED';
export const DEMUR_CONTRACT = 'document/demur/DEMUR_CONTRACT';
export const CONTRACT_IS_DEMUR = 'document/sign/CONTRACT_IS_DEMUR';
export const GET_DOMAIN_CERT = 'pdf/GET_DOMAIN_CERT';
export const DOMAIN_CERT = 'pdf/DOMAIN_CERT';

export const VERIFY_TOKEN = 'document/verify/VERIFY_TOKEN';
export const TOKEN_STATUS = 'document/verify/TOKEN_STATUS';
export const SIGNER_ROLE = 'document/verify/SIGNER_ROLE';

export const GET_CONTRACT_DATA_FORM = 'document/get/GET_CONTRACT_DATA_FORM';
export const CONTRACT_FORM_FETCH = 'document/set/CONTRACT_FORM_FETCH';
export const UPDATE_CONTRACT_FORM_DATA = 'document/create/UPDATE_CONTRACT_FORM_DATA';
export const REJECT_OBJECTION = 'document/reject/REJECT_OBJECTION';
export const CONTRACT_IS_LOADED = 'document/get/CONTRACT_IS_LOADED';
export const OBJECT_IS_REJECTED = 'document/get/OBJECT_IS_REJECTED';
export const OBJECT_REJECTED_FAIL = 'document/get/OBJECT_REJECTED_FAIL';

export const RESET_IS_LOADED = 'document/isLoaded/RESET_IS_LOADED';

export const FAILURE = 'saga/failure/FAILURE';

export const SEND_NOTARISA = 'document/send/SEND_NOTARISA';
export const IS_SENT_NOTARISA = 'document/send/IS_SENT_NOTARISA';
export const ADMIN_UPDATE_CONTRACT_FORM_DATA = 'document/send/ADMIN_UPDATE_CONTRACT_FORM_DATA';

export const CANCEL_CONTRACT = 'document/create/CANCEL_CONTRACT';
export const CONTRACT_IS_CANCELED = 'document/sign/CONTRACT_IS_CANCELED';

export const SEARCH_CONTRACT = 'document/search/SEARCH_CONTRACT';
export const CONTRACT_DATA = 'document/search/CONTRACT_DATA';

export const SET_PREVIEW_DATA = 'document/preview/SET_PREVIEW_DATA';

export const PERSIST_ACTIVE_TAB = 'document/tab/PERSIST_ACTIVE_TAB';

export const SAVE_NEW_CONTRACT_PDF = 'document/edit/SAVE_NEW_CONTRACT_PDF';
export const PDF_MODIFIED = 'document/edit/PDF_MODIFIED';

export const SAVE_DRAFT = 'document/save/SAVE_DRAFT';
export const DRAFT_IS_SAVED = 'document/save/DRAFT_IS_SAVED';
export const GET_DRAFT = 'document/get/GET_DRAFT';
export const DRAFT_DATA = 'document/get/DRAFT_DATA';

export const LIST_NOTIFICATION_CONTRACT = 'notification/get/LIST_NOTIFICATION_CONTRACT';
export const NOTIFICATION_CONTRACT_DATA = 'notification/get/NOTIFICATION_CONTRACT_DATA';
export const SOURCE_URL = 'url/SOURCE_URL';

export const GET_DOC_PRICE = 'payment/get/GET_DOC_PRICE';
export const GET_DEFAULT_PRICE = 'payment/get/GET_DEFAULT_PRICE';
export const SET_DOC_PRICE = 'payment/set/SET_DOC_PRICE';

export const SET_EDIT_SPINNER = 'edit/spinner/SET_EDIT_SPINNER';